import React, { PureComponent } from 'react';
import { DialogContainer, TextField, CircularProgress, SelectionControlGroup } from 'react-md';

const DEFAULT_RULE_POINTS = 'everyone'
const DEFAULT_RULE_STUCK = 'player'

export default class CreateRoomDialog extends PureComponent {
    state = {
      loading: false,
      name: '',
      rulePoints: DEFAULT_RULE_POINTS,
      ruleStuck: DEFAULT_RULE_STUCK
    };

    onDialogHidden = () => {}

    submit = () => {
        
        const { name, ruleStuck, rulePoints } = this.state;

        this.setState({ loading: true });

        if (this.props.onSubmit) {
            this.props.onSubmit(name, ruleStuck, rulePoints);
        }
    }

    handleNameChange = (name) => {
        
        this.setState({ name });
    }

    handleStuckRuleChange = (ruleStuck) => {

      this.setState({ ruleStuck: ruleStuck });
    }

    handlePointsRuleChange = (rulePoints) => {

      this.setState({ rulePoints: rulePoints });
    }

    onFocus = (event) => event.target.select();
  
    render() {
      
      const actions = [{
        id: 'dialog-cancel',
        secondary: true,
        children: 'Cancel',
        onClick: this.props.onCancel,
        disabled: this.state.loading
      }, {
        id: 'dialog-ok',
        secondary: true,
        children: 'Ok',
        onClick: this.submit,
        disabled: this.state.loading
      }];

      const itemLoading = <CircularProgress id='progress'/>;

      const itemContents = <div>
        <TextField
          id="field-1"
          label={this.props.label}
          value={this.state.name}
          onChange={this.handleNameChange}
          onFocus={this.onFocus}
          className="md-cell md-cell--12" />

        <SelectionControlGroup
          id="create-room-rules-points"
          name="create-room-radiogroup-rules-points"
          type="radio"
          onChange={this.handlePointsRuleChange}
          label="Points?"
          defaultValue={DEFAULT_RULE_POINTS}
          controls={[{
            label: 'Everyone',
            value: DEFAULT_RULE_POINTS
          }, {
            label: 'Opponents',
            value: 'opponents'
          }]} />
        <SelectionControlGroup
          id="create-room-rules-stuck"
          name="create-room-radiogroup-rules-stuck"
          type="radio"
          onChange={this.handleStuckRuleChange}
          label="Stuck?"
          defaultValue={DEFAULT_RULE_STUCK}
          controls={[{
            label: 'Player',
            value: DEFAULT_RULE_STUCK
          }, {
            label: 'Team',
            value: 'team'
          }]} />
      </div>;

        return <DialogContainer
            id="field-dialog-create-room"
            title={this.props.title}
            visible={this.props.visible}
            actions={actions}
            onHide={this.onDialogHidden}
            contentClassName="md-grid"
        >
            {this.state.loading ? itemLoading : itemContents}
        </DialogContainer>;
    }
}


// WEBPACK FOOTER //
// ./src/CreateRoomDialog.jsx